$(".section__aside .current-item").on("click", function() {
  $(this).next().toggle();
});



// WEBPACK FOOTER //
// ../assets/js/account-side-toggle.js